import random from 'lodash/random';
import { useRef } from 'react';

export const InterimResultLoading = () => {
  const sentencesSize = useRef(random(100, 240));
  return (
    <span
      className="mx-2 inline-block h-3 animate-pulse rounded-md bg-muted"
      style={{ width: sentencesSize.current }}
    />
  );
};
